import React, { useEffect, useRef } from 'react';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import { ERROR_BOUNDARY_ID_SAMPLE_PROJECT_BOARD_NUDGE } from '../../common/constants.tsx';
import { sampleProjectBoardEntryPoint } from './entrypoint.tsx';

const entryPointParams = {};
const runtimeProps = {};

export const SampleProjectBoardNudgeAsync = () => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		sampleProjectBoardEntryPoint,
		entryPointParams,
	);

	const firstLoadRef = useRef(true);

	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		if (firstLoadRef.current) {
			entryPointActions.load();
			firstLoadRef.current = false;
		}
	}, [entryPointActions]);

	return (
		<JiraEntryPointContainer
			id={ERROR_BOUNDARY_ID_SAMPLE_PROJECT_BOARD_NUDGE}
			packageName="jiraBoardOnboarding"
			entryPointReferenceSubject={entryPointReferenceSubject}
			fallback={<></>}
			runtimeProps={runtimeProps}
		/>
	);
};
